var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsApiDocumentation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons-api-documentation",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "bounds",
    width: 16,
    height: 16,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10905",
    "data-name": "Path 10905",
    d: "M19.448,5.985V5.921L16.743,3.216h-.034v.009H9.272V15.3H19.434l.014-8.365H20.72l0,8.355a1.283,1.283,0,0,1-1.281,1.281H9.113A1.114,1.114,0,0,1,8,15.464V3.066A1.114,1.114,0,0,1,9.113,1.953h7.6V1.944h.1a1.105,1.105,0,0,1,.787.326l2.8,2.8a1.105,1.105,0,0,1,.326.787v.131ZM16.569,8.9a2.761,2.761,0,0,1-.423,1.468l1.524,1.511s.217.215.217.215a.636.636,0,0,1-.9.9l-1.741-1.726A2.779,2.779,0,1,1,16.569,8.9ZM15.3,8.9a1.51,1.51,0,1,0-1.51,1.51A1.512,1.512,0,0,0,15.3,8.9Z",
    transform: "translate(-6.36 -1.511)",
    fill: "#c6cacc"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsApiDocumentation);
export default __webpack_public_path__ + "static/media/icons-api-documentation.65c31519.svg";
export { ForwardRef as ReactComponent };